import { useFetchList } from 'store'
import { useGlobal } from '@jimmyboys/liita-ui/dist/components/GlobalContext'
import Widget from '@jimmyboys/liita-ui/dist/components/Widget'
import Collection from '@jimmyboys/liita-ui/dist/components/Collection'
import useQueryParams from '@jimmyboys/liita-ui/dist/hooks/useQueryParams'

import queryString from 'query-string'
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min'
import ProtocolRow, { ProtocolHeader, ProtocolRowSkeleton } from './ProtocolRow'

import styles from '../ProtocolsController.module.sass'
import NoData from 'components/general/NoData/NoData'
import LazyLoader from 'components/general/LazyLoader/LazyLoader'
import ProtocolsFilters from './ProtocolsFilters'

const DEFAULT_PAGE_SIZE = 24

const ProtocolsController = () => {
	const location = useLocation()
	const { i18n, screenSize } = useGlobal()

	const [queryParams, , setSearchParams] = useQueryParams(location)
	const pageList = new Array(parseInt(queryParams.page, 10) || 1)
	const pagesRequests = pageList.fill(null).map((_, index) => {
		const pageQueryParams = {
			...queryParams,
			page: index,
			pageSize: DEFAULT_PAGE_SIZE,
		}
		const qs = queryString.stringify(pageQueryParams)
		const pageUrl = `/rules/protocols?${qs || ''}`
		return pageUrl
	})

	const {
		contents: [...pages],
	} = useFetchList([...pagesRequests], [], undefined, true)

	const isLoading = pages.some(({ state }) => state === 'loading')

	const lastPageContents = pages[pages.length - 1]?.contents

	const hasMore =
		Array.isArray(lastPageContents) &&
		lastPageContents.length === DEFAULT_PAGE_SIZE

	const items = pages
		.map(({ state, contents }) => {
			const isPageLoading = state === 'loading'
			return isPageLoading
				? new Array(DEFAULT_PAGE_SIZE).fill({
						$cardName: 'ProtocolRowSkeleton',
						$layout: screenSize,
				  })
				: Array.isArray(contents)
				? contents.map((data) => ({
						...data,
						$cardName: 'ProtocolRow',
						$layout: screenSize,
				  }))
				: []
		})
		.flat()

	return (
		<>
			<Widget paddings={['small', 'normal', '']} applyMaxWidth>
				<ProtocolsFilters />
			</Widget>
			<Widget
				className={styles['list-header']}
				paddings={['normal', 'normal', '']}
				applyMaxWidth
			>
				<ProtocolHeader />
			</Widget>
			<Widget paddings={['small', 'normal', '']} applyMaxWidth>
				{!isLoading && !items.length ? (
					<NoData
						applyMaxWidth
						paddings={['normal', 'normal']}
						message={i18n`Current filters do not match any process.\n\nTry with different filters or reset them.`}
					/>
				) : null}
				<Collection
					items={items}
					itemsHeight={50 + 10}
					renderAhead={20}
					cards={{
						ProtocolRowSkeleton,
						ProtocolRow,
					}}
				/>
			</Widget>
			<Widget paddings={['', 'normal', 'normal']} applyMaxWidth>
				<LazyLoader
					isLoading={isLoading}
					hasMore={hasMore}
					onVisible={() => {
						const nextPage = parseInt(queryParams.page, 10) || 1
						setSearchParams({ page: nextPage + 1 })
					}}
				/>
			</Widget>
		</>
	)
}

export default ProtocolsController
